import type { FrontendNotebook } from '../contexts/NotebooksContext';
import { tryParsePortalDraft } from '../portal/portalDraftEnvelope';

function isLikelyImageUrl(s: string | undefined | null): boolean {
  if (!s || typeof s !== 'string') return false;
  const t = s.trim();
  if (!t) return false;
  try {
    const u = new URL(t);
    return u.protocol === 'http:' || u.protocol === 'https:';
  } catch {
    return false;
  }
}

/** Hero image URL for list thumbnails (recipe / movie / event / article portal drafts). */
export function notebookDraftHeroImageUrl(notebook: FrontendNotebook): string | null {
  const raw = notebook.draft?.content?.trim();
  if (!raw) return null;
  const env = tryParsePortalDraft(raw);
  if (!env) return null;
  switch (env.kind) {
    case 'recipe':
      return isLikelyImageUrl(env.payload.image) ? env.payload.image.trim() : null;
    case 'movie':
      return isLikelyImageUrl(env.payload.thumbnail_url) ? env.payload.thumbnail_url.trim() : null;
    case 'event':
      return isLikelyImageUrl(env.payload.og_image) ? env.payload.og_image!.trim() : null;
    case 'article': {
      const og = env.payload.og_image;
      if (isLikelyImageUrl(og)) return og!.trim();
      const block = env.payload.content_blocks?.find(
        (b) => b.type === 'image' && isLikelyImageUrl(b.src)
      );
      return block?.src?.trim() ?? null;
    }
    default:
      return null;
  }
}
